import React from 'react';
import { Card, Row, Col, Statistic, Spin, Alert } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  CarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_STATS } from '../graphql/queries';
import { formatCurrency, DEFAULT_CURRENCY } from '../utils/currency';

export const Dashboard: React.FC = () => {
  const { loading, error, data } = useQuery(GET_DASHBOARD_STATS, {
    pollInterval: 30000, // Refetch every 30 seconds
  });

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error loading dashboard"
        description={error.message}
        type="error"
        showIcon
      />
    );
  }

  const stats = data?.getDashboardStats;

  return (
    <div>
      <h1>Dashboard</h1>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Users"
              value={stats?.totalUsers || 0}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Organizations"
              value={stats?.totalOrganizations || 0}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Parkings"
              value={stats?.totalParkings || 0}
              prefix={<CarOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Slots"
              value={stats?.totalSlots || 0}
              prefix={<CarOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Available Slots"
              value={stats?.availableSlots || 0}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Active Sessions"
              value={stats?.activeSessions || 0}
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={12}>
          <Card>
            <Statistic
              title="Today's Revenue"
              value={stats?.todayRevenue || 0}
              prefix={<DollarOutlined />}
              precision={2}
              suffix={DEFAULT_CURRENCY}
              valueStyle={{ color: '#3f8600' }}
            />
            <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
              <span style={{ marginRight: 16 }}>
                Card: {formatCurrency(stats?.todayCardRevenue || 0)} ({(stats?.todayCardRevenuePercent || 0).toFixed(0)}%)
              </span>
              <span>
                Cash: {formatCurrency(stats?.todayCashRevenue || 0)} ({(stats?.todayCashRevenuePercent || 0).toFixed(0)}%)
              </span>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={12}>
          <Card>
            <Statistic
              title="Monthly Revenue"
              value={stats?.monthlyRevenue || 0}
              prefix={<DollarOutlined />}
              precision={2}
              suffix={DEFAULT_CURRENCY}
              valueStyle={{ color: '#1890ff' }}
            />
            <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
              <span style={{ marginRight: 16 }}>
                Card: {formatCurrency(stats?.monthlyCardRevenue || 0)} ({(stats?.monthlyCardRevenuePercent || 0).toFixed(0)}%)
              </span>
              <span>
                Cash: {formatCurrency(stats?.monthlyCashRevenue || 0)} ({(stats?.monthlyCashRevenuePercent || 0).toFixed(0)}%)
              </span>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
